import { useState } from 'react';
import { acknowledgeAlert } from '../utils/api';
import { useToast } from '../context/ToastContext';

// useAlertAcknowledgements acknowledges a device's alerts and keeps the result
// locally, so the alert turns yellow at once without reloading the dashboard.
// Acknowledging is one-way: there is no undo. A failed request rolls it back.
//
// State is keyed by alert id: when the condition clears or changes, the server
// opens a new, unacknowledged alert, and its new id starts from the server's value.
export const useAlertAcknowledgements = (deviceId) => {
        const { showToast } = useToast();
        const [acked, setAcked] = useState({}); // alert id -> acknowledged_at

        const acknowledgedAt = (alert) => {
                if (!alert) return null;
                return alert.id in acked ? acked[alert.id] : alert.acknowledged_at;
        };

        const isAcknowledged = (alert) => acknowledgedAt(alert) != null;

        const acknowledge = async (alert) => {
                if (!alert || isAcknowledged(alert)) return;
                setAcked(a => ({ ...a, [alert.id]: new Date().toISOString() }));
                try {
                        const res = await acknowledgeAlert(deviceId, alert.id);
                        if (!res.ok) throw new Error(`status ${res.status}`);
                        const { data } = await res.json();
                        setAcked(a => ({ ...a, [alert.id]: data.acknowledged_at }));
                } catch (e) {
                        console.error('Failed to acknowledge alert', e);
                        setAcked(a => ({ ...a, [alert.id]: null }));
                        showToast('error', 'Could not acknowledge the alert.');
                }
        };

        return { acknowledgedAt, isAcknowledged, acknowledge };
};
